require('./RACustomPlanByObjectiveView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const ReactDOM = require('react-dom');
const { withRouter } = require('react-router-dom');

// @commons
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');
const RAOKCover = require('../../components/commons/RAOKCover/RAOKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { EditAlias } = require('commonsComponents/editAlias');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RACommissionCondition = require('../../components/RACommissionCondition/RACommissionCondition');
const RASchemeSettingContribution = require('../../components/RASchemeSettingContribution/RASchemeSettingContribution');
const RAStrategiesGraph = require('../../components/RAStrategiesGraph/RAStrategiesGraph');
const RAIndexRiskModal = require('../../components/RAIndexRiskModal/RAIndexRiskModal');
const RATimeHorizonCheck = require('../../components/RATimeHorizonCheck/RATimeHorizonCheck');
const RARiskButton = require('../../components/RARiskButton/RARiskButton');

// @contactCenter
const RAStrategyCardsInfo = require('../../components/contactCenter/RAStrategyCardsInfo/RAStrategyCardsInfo');

// @actions
const expectedProfitabilityActions = require('../../actions/RAExpectedProfitability');
const raCustomPlanByObjectiveActions = require('../../actions/RACustomPlanByObjective');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');
const raManagementPlanActions = require('../../actions/RAManagementPlan');
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const raTimeHorizonCheckActions = require('../../actions/RATimeHorizonCheck');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');
const raSaveSimulationActions = require('../../actions/RASaveSimulation');
const RASetGoalActions = require('../../actions/RASetGoal');
const notification = require('actions/notifications');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;
const { base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const {
    formatDate,
    getNumOfDaysBetweenDates,
} = require('utilities/dateHelper');
const { recordLink } = require('utilities/tagging');
const RAScrollUtils = require('../../utilities/RAScrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { Portfolios } = require('../../utilities/RAPortfolioHelper');

const WebappRender = require('components/conditionalRender/webappRender');

// @constants
const { CONTENT_TYPE_PDF } = require('constants/index');
const {
    CUSTOM_PLAN_BY_OBJECTIVE_TITLE_MAX_LENGTH,
    DATE_FORMAT_TIME_HORIZON_CHECK,
    HIRE_OBJECTIVE_PLAN_URL,
    MINIMUM_OBJECTIVE_AMOUNT,
    MYPROFILE_BROKER_ROBO_URL,
    MYPROFILE_ROBO_SETGOAL,
    RA_NO_STRATEGY_SELECTED,
    RA_PROJECTION_CHART_ALL_PRODUCTS,
    RA_CUSTOM_PLAN_OBJ_VIEW,
    RA_SIMULATION_SCROLL_BUFFER,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
    TIME_HORIZON_CHECK_ERROR,
    TIME_HORIZON_CHECK_WARNING,
    TIME_HORIZON_CHECK_NOT_PERFORMED,
} = require('../../raConstants/index');

const { DATE_FORMAT_ES } = require('constants/index');

const { ROBO_ZERO_COMMISSION } = require('constants/flagBasedFeatures');

const FREQ_BY_PERIODICITY = {
    [CONTRIBUTION_PERIOD_DAILY]: 365,
    [CONTRIBUTION_PERIOD_WEEKLY]: 52,
    [CONTRIBUTION_PERIOD_MONTHLY]: 12,
};
class RACustomPlanByObjectiveView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            msgFlag: false,
            isScrollHeightSet: false,
        };
        this.handleTitleEdit = this.handleTitleEdit.bind(this);
        this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
        this.handleContributionDayChange = this.handleContributionDayChange.bind(
            this,
        );
        this.handleHireClick = this.handleHireClick.bind(this);
        this.handleManagementPDFClick = this.handleManagementPDFClick.bind(
            this,
        );
        this.handleObjectiveEndDateChange = this.handleObjectiveEndDateChange.bind(
            this,
        );
        this.setSaveSimulationButtonEnabled = this.setSaveSimulationButtonEnabled.bind(
            this,
        );
        this.handleObjectiveEndDateError = this.handleObjectiveEndDateError.bind(
            this,
        );
        this.buildModal = this.buildModal.bind(this);
        this.handleOnLinkClick = this.handleOnLinkClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.shortStrategyNumber = this.shortStrategyNumber.bind(this);
        this.saveSimulation = this.saveSimulation.bind(this);
        this.handleSaveSimulation = this.handleSaveSimulation.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleValidateTimeHorizonCheck = this.handleValidateTimeHorizonCheck.bind(
            this,
        );
        this.handleResetClick = this.handleResetClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        const { immCustomPlanByObjective, immRAFeatureFlag } = this.props;
        const { isScrollHeightSet } = this.state;
        const immPrevCustomPlanByObjective = prevProps.immCustomPlanByObjective;
        const immPrevRAFeatureFlag = prevProps.immRAFeatureFlag;
        const goalAmountError = immCustomPlanByObjective.get('errorAmountMin');
        const initialAmountError = immCustomPlanByObjective.get(
            'errorInitialMin',
        );
        const recurringAmountError = immCustomPlanByObjective.get(
            'errorPeriodicityMin',
        );
        const amountValid =
            !goalAmountError && !initialAmountError && !recurringAmountError;
        const featureFlag =
            immRAFeatureFlag.get('isFetching') !==
            immPrevRAFeatureFlag.get('isFetching');
        const keyArrayToCheck = [
            'objectiveEndDate',
            'recurringContributionAmount',
            'contributionDay',
            'periodicity',
            'objective',
            'objectiveAmount',
            'initialContributionAmount',
        ];
        const isSomeInputChanged = keyArrayToCheck.reduce(
            (acc, key) =>
                acc ||
                immCustomPlanByObjective.get(key) !==
                    immPrevCustomPlanByObjective.get(key),
            false,
        );
        if (isSomeInputChanged) {
            this.setSaveSimulationButtonEnabled();
        }
        if (!featureFlag) {
            this.props.fetchFeatureFlag();
        }

        // Call this.fetchStrategies() if any of following immCustomPlanByObjective
        // attributes' value changed
        const sensibleAttrs = [
            'objectiveEndDate',
            'initialContributionAmount',
            'recurringContributionAmount',
            'periodicity',
            'contributionDay',
        ];

        for (let i = 0; i < sensibleAttrs.length; i++) {
            const attr = sensibleAttrs[i];
            const actualValue = immCustomPlanByObjective.get(attr);
            const prevValue = immPrevCustomPlanByObjective.get(attr);

            if (String(actualValue) !== String(prevValue) && amountValid) {
                this.fetchStrategies();
                break;
            }
        }

        if (!isScrollHeightSet) {
            this.props.setScrollHeight();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
        RAScrollUtils.resetElems();

        if (__CONTACT_CENTER__) this.props.resetMaxTypeOfProduct();
    }

    handleScroll() {
        const { immCustomPlanByObjective } = this.props;
        const ctaFooterSection = ReactDOM.findDOMNode(this.raCtaFooter);
        const raFooterSectionNode = ReactDOM.findDOMNode(this.raFooter);
        const pageScrollHeight = immCustomPlanByObjective.get(
            'pageScrollHeight',
        );

        if (!__CONTACT_CENTER__) {
            RAScrollUtils.scrollHandler(
                RA_CUSTOM_PLAN_OBJ_VIEW,
                ctaFooterSection,
                pageScrollHeight,
                RA_SIMULATION_SCROLL_BUFFER,
                raFooterSectionNode,
            );
        }
    }

    handleValidateTimeHorizonCheck() {
        this.props.timeHorizonCheck(
            this.handleHireClick,
            this.shortStrategyNumber,
        );
    }

    fetchStrategies() {
        const { requestProjectionChart, immCustomPlanByObjective } = this.props;
        const initialContributionAmount = immCustomPlanByObjective.get(
            'initialContributionAmount',
        );
        const recurringContributionAmount = immCustomPlanByObjective.get(
            'recurringContributionAmount',
        );
        const objectiveEndDate = immCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const periodicity = immCustomPlanByObjective.get('periodicity');
        const contributionDay = immCustomPlanByObjective.get('contributionDay');

        if (
            initialContributionAmount == null ||
            initialContributionAmount === '' ||
            periodicity === '' ||
            recurringContributionAmount == null ||
            !objectiveEndDate
        ) {
            return;
        }

        const nDays = Math.abs(getNumOfDaysBetweenDates(objectiveEndDate));
        const chartYears = nDays / 365;
        const freq = FREQ_BY_PERIODICITY[periodicity] || 1;
        if (
            recurringContributionAmount >= 1 &&
            freq === CONTRIBUTION_PERIOD_MONTHLY
        ) {
            requestProjectionChart({
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: initialContributionAmount,
                freq,
                mntPayment: recurringContributionAmount,
                cutDay: contributionDay,
            });
        } else {
            requestProjectionChart({
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: initialContributionAmount,
                freq,
                mntPayment: recurringContributionAmount,
            });
        }
    }

    handleTitleEdit(value) {
        this.props.updateObjective(value);
    }

    handlePeriodicityChange(ev) {
        this.props.setPeriodicity(ev.value);
    }

    handleObjectiveEndDateChange(value) {
        this.props.setObjectiveEndDate(value);
        if (!!value) {
            this.props.setTimeHorizonCheck(
                value.format(DATE_FORMAT_TIME_HORIZON_CHECK),
            );
        }
    }

    handleObjectiveEndDateError() {
        const { immCustomPlanByObjective } = this.props;
        if (!immCustomPlanByObjective.get('objectiveEndDateError')) {
            this.props.setObjectiveEndDateError();
        }
    }

    handleContributionDayChange(ev) {
        const { immCustomPlanByObjective } = this.props;
        const selectedDay = parseInt(ev.currentTarget.dataset.id);
        if (selectedDay !== immCustomPlanByObjective.get('contributionDay')) {
            this.props.setContributionDay(selectedDay);
        }
    }

    handleResetClick() {
        const { resetSchemeContribution, resetMaxTypeOfProduct } = this.props;
        resetSchemeContribution();
        resetMaxTypeOfProduct();
    }

    saveSimulation() {
        this.props.saveSimulation(this.props.history, true);
    }

    shortStrategyNumber() {
        const { immTimeHorizonCheck, immCustomPlanByObjective } = this.props;
        const maxTypeOfProduct = immTimeHorizonCheck.get('maxTypeOfProduct');
        const selectedStrategy = immCustomPlanByObjective.get(
            'selectedStrategy',
        );

        if (
            maxTypeOfProduct < selectedStrategy &&
            selectedStrategy !== RA_NO_STRATEGY_SELECTED
        ) {
            this.props.setSelectedStrategy(RA_NO_STRATEGY_SELECTED);
        }
    }

    handleHireClick() {
        this.props.saveSimulation(this.props.history, true);

        recordLink('interaccion en inversion por objetivos', 'contratar');
        this.props.history.push(HIRE_OBJECTIVE_PLAN_URL);
    }

    handleManagementPDFClick() {
        const documentContent = this.props.immHireManagementPlan.get('pdfLink');
        downloadAsFile(
            base64ToBlob(documentContent),
            CONTENT_TYPE_PDF,
            `Contrato GD.pdf`,
        ); // TBC: Filename

        recordLink('interaccion en inversion por objetivos', 'ver contrato');
    }

    getBreadcrumb() {
        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText('raCustomPlanByObjective-myObjectives'),
                url: MYPROFILE_ROBO_SETGOAL,
            },
            {
                text: formatText('raCustomPlanByObjective-investmentPlan'),
                url: '',
            },
        ];
    }

    buildHeader(title, clientRiskProfile, hireButtonDisabled, namesHistory) {
        const breadcrumb = this.getBreadcrumb();
        const loadingButton = this.props.immTimeHorizonCheck.get('isFetching');
        const nameError =
            namesHistory &&
            namesHistory.some(
                names => names.toLowerCase() === title.toLowerCase(),
            );
        let errorMessage = 'raManagementPlan-raManagementPlan_customNameError';
        if (!title) {
            errorMessage =
                'raManagementPlan-raManagementPlan_customNameEmptyError';
        }
        return (
            <div className="ra-custom-plan-by-objective-view__header">
                <div className="ra-custom-plan-by-objective-view__header-breadcrumb">
                    <OKBreadcrumb mapping={breadcrumb} />
                </div>
                <div className="ra-custom-plan-by-objective-view__header-title">
                    <EditAlias
                        alias={title}
                        postAlias={this.handleTitleEdit} //eslint-disable-line
                        limit={CUSTOM_PLAN_BY_OBJECTIVE_TITLE_MAX_LENGTH}
                        fontSize="34px MarkOT"
                        isHeading={true}
                        isEmptyAllowed={true}
                        error={nameError || !title}
                        errorMessage={formatText(errorMessage)}
                    />
                </div>
                <div className="ra-custom-plan-by-objective-view__header-extra-content">
                    <div className="ra-custom-plan-by-objective-view__header-profile">
                        <div>
                            <FormattedText
                                value="raManagementPlan-inversorProfile"
                                className="ra-custom-plan-by-objective-view__header-profile-label"
                            />
                        </div>
                        <div className="ra-custom-plan-by-objective-view__header-profile-type">
                            {clientRiskProfile}
                        </div>
                    </div>
                    <div className="ra-custom-plan-by-objective-view__header-info">
                        <FormattedText value="raCustomPlanByObjective-headerInfo" />
                    </div>
                    <div className="ra-custom-plan-by-objective-view__header-button">
                        <OKButton
                            onClick={this.handleHireClick}
                            disabled={hireButtonDisabled}
                            loading={loadingButton}
                        >
                            <FormattedText value="raCustomPlanByObjective-ctaHireButton" />
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    buildMessage() {
        this.props.notificationSuccess(formatText('raManagementPlan-saveMsg'));
        this.setState({ msgFlag: false });
    }

    buildInfoSection() {
        const message = this.state.msgFlag ? this.buildMessage() : null;
        const moreInfoLinkManagement = (
            <OKLink
                modifier="emphasize"
                onClick={this.handleManagementPDFClick}
            >
                <FormattedText value="raManagementPlan-moreInfoText3Link" />
            </OKLink>
        );

        return (
            <div className="ra-custom-plan-by-objective-view__section-info">
                <div className="ra-custom-plan-by-objective-view__more-info-link">
                    <p>
                        <FormattedTextWithComponents
                            value="raManagementPlan-moreInfoText3"
                            injectedComponents={[moreInfoLinkManagement]}
                        />
                    </p>
                </div>
                {message}
            </div>
        );
    }

    buildFooter(hireButtonDisabled) {
        const {
            immCustomPlanByObjective,
            immTimeHorizonCheck,
            flagBasedFeatures,
            immCheckStatus,
        } = this.props;
        const title = immCustomPlanByObjective.get('objective');
        const loadingButton = immTimeHorizonCheck.get('isFetching');
        const commisionCondition =
            flagBasedFeatures.get(ROBO_ZERO_COMMISSION) &&
            immCheckStatus.get('zeroCommission') ? (
                <RACommissionCondition modifier={true} />
            ) : null;

        return (
            <div
                className="ra-footer__content ra-custom-plan-by-objective-view__footer"
                ref={componentInstance => {
                    this.raFooter = componentInstance;
                }}
            >
                <div className="ra-custom-plan-by-objective-view__commision-condition">
                    {commisionCondition}
                </div>
                <div className="ra-custom-plan-by-objective-view__footer-buttons">
                    <WebappRender>
                        <div className="ra-custom-plan-by-objective-view__save-button">
                            <OKButton
                                onClick={this.handleSaveSimulation}
                                disabled={
                                    immCustomPlanByObjective.get(
                                        'isSaveSimulationButtonDisabled',
                                    ) || !title
                                }
                                loading={loadingButton}
                                modifier="secondary"
                                inverse={true}
                            >
                                <FormattedText value="raManagementPlan-saveStrategy" />
                            </OKButton>
                        </div>
                    </WebappRender>
                    <OKButton
                        onClick={this.handleValidateTimeHorizonCheck}
                        disabled={hireButtonDisabled}
                        loading={loadingButton}
                    >
                        <FormattedText value="raCustomPlanByObjective-ctaHireButton" />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildModal() {
        return (
            <RAIndexRiskModal
                isModalOpen={this.state.isModalOpen}
                onModalClose={this.handleCloseModal}
            />
        );
    }

    handleCloseModal() {
        this.setState({
            isModalOpen: false,
        });
    }

    handleOnLinkClick() {
        recordLink(
            'interaccion en inversion por objetivos',
            'ver indices de riesgo',
        );
        this.setState({
            isModalOpen: true,
        });
    }

    shouldDisableHireButton() {
        const {
            immTimeHorizonCheck,
            immCustomPlanByObjective,
            immSuitabilityTest,
            immPortfoliosNameHistory,
        } = this.props;
        const objectiveAmount = immCustomPlanByObjective.get('objectiveAmount');
        const initialContributionAmount = immCustomPlanByObjective.get(
            'initialContributionAmount',
        );
        const maxInvestmentProfile = immSuitabilityTest.getIn(
            ['results', 0, 'maxTypeOfProduct'],
            0,
        );
        const candidateStrategy = immCustomPlanByObjective.get(
            'selectedStrategy',
        );
        const selectedStrategy =
            maxInvestmentProfile >= candidateStrategy
                ? candidateStrategy
                : null;
        const title = immCustomPlanByObjective.get('objective');
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const nameError =
            namesHistory &&
            namesHistory.some(
                names => names.toLowerCase() === title.toLowerCase(),
            );

        return (
            nameError ||
            !title ||
            !objectiveAmount ||
            !initialContributionAmount ||
            !selectedStrategy ||
            immTimeHorizonCheck.get('status') === TIME_HORIZON_CHECK_ERROR ||
            immCustomPlanByObjective.get('errorAmountMin') ||
            immCustomPlanByObjective.get('errorInitialMin') ||
            immCustomPlanByObjective.get('errorPeriodicityMin') ||
            immCustomPlanByObjective.get('objectiveEndDateError')
        );
    }

    shouldRenderLoading() {
        const { immSimulation } = this.props;

        return immSimulation.get('isFetching');
    }

    handleSaveSimulation() {
        this.props.saveSimulationRequest(this.props.history);
        this.setState({
            msgFlag: true,
        });
        this.props.disableSaveSimulationButton(true);
    }

    setSaveSimulationButtonEnabled() {
        this.setState({
            msgFlag: false,
        });
        this.props.disableSaveSimulationButton(false);
    }

    buildStrategyGraphMessage() {
        return (
            <div className="ra-custom-plan-by-objective-view__message-section">
                <OKMessage type="informative">
                    <FormattedText
                        value={`raStrategiesGraph-raStrategiesGraph_investmentExceedThanGoalMessage`}
                    />
                </OKMessage>
            </div>
        );
    }

    buildSuitabilityWarningMessage(clientName, date) {
        return (
            <BlockInfo extraClass="ra-custom-plan-by-objective-view__row-separator">
                <FormattedText
                    value="cc_raCustomPlanByObjective-suitabilityWarningMessage"
                    injectedStrings={[clientName, date]}
                />
            </BlockInfo>
        );
    }

    buildMinimumAmountInvestmentMessage(clientName) {
        return (
            <BlockInfo extraClass="ra-custom-plan-by-objective-view__row-separator">
                <FormattedText
                    value="cc_raCustomPlanByObjective-minimumInvestmentWarningMessage"
                    injectedStrings={[clientName, MINIMUM_OBJECTIVE_AMOUNT]}
                />
            </BlockInfo>
        );
    }

    buildInvestmentProfileMessage(selectedCard, clientName, maxAvailable) {
        return (
            <div className="ra-custom-plan-by-objective-view__investment-profile-info-block">
                <RAStrategyCardsInfo
                    selectedCard={selectedCard}
                    clientName={clientName}
                    suitableProfile={maxAvailable}
                />
            </div>
        );
    }

    buildPrePurchaseConfirmationMessage(
        clientName,
        portfolioName,
        initialInvestment,
        totalPeriodicContribution,
        minProfitability,
        maxProfitability,
        minExpectedAmount,
        maxExpectedAmount,
        periodicContributionText,
        objectiveEndDate,
    ) {
        return (
            <div className="row">
                <div className="col-md-12">
                    <p>
                        <FormattedText
                            className="ra-custom-plan-by-objective-view__mandatory-text-heading"
                            value="cc_raCustomPlanByObjective-mandatoryText"
                        />
                    </p>
                    <p>
                        <FormattedText
                            value="cc_raCustomPlanByObjective-prePurchaseConfirmationMessage"
                            injectedStrings={[
                                clientName,
                                portfolioName,
                                initialInvestment,
                                totalPeriodicContribution,
                                minProfitability,
                                maxProfitability,
                                minExpectedAmount,
                                maxExpectedAmount,
                                periodicContributionText,
                                objectiveEndDate,
                                clientName,
                            ]}
                        />
                    </p>
                </div>
            </div>
        );
    }

    buildPurchaseSummaryMessage(
        clientName,
        strategy,
        goalType,
        goalName,
        initialContributionAmount,
        objectiveAmount,
        endDate,
        monthlyContributionAmount,
        totalPeriodicContribution,
        contributionDay,
    ) {
        const { immCustomPlanByObjective } = this.props;
        const hasMonthlhyPeriodicity =
            immCustomPlanByObjective.get('periodicity') ==
            CONTRIBUTION_PERIOD_MONTHLY;
        let monthlyContributionDetails;

        if (hasMonthlhyPeriodicity) {
            monthlyContributionDetails = (
                <div className="ra-custom-plan-by-objective-view__contribution-box-wrapper">
                    <FormattedText value="cc_raCustomPlanByObjective-periodicContributionMonthly" />
                    <div className="ra-custom-plan-by-objective-view__contribution-box-info">
                        <FormattedText
                            value="cc_raCustomPlanByObjective-contributionAmount"
                            injectedStrings={[monthlyContributionAmount]}
                        />
                    </div>
                    <div className="ra-custom-plan-by-objective-view__contribution-box-info">
                        <FormattedText value="cc_raCustomPlanByObjective-monthlyContribution" />
                    </div>
                    <div className="ra-custom-plan-by-objective-view__contribution-box-info">
                        <FormattedText
                            value="cc_raCustomPlanByObjective-contributionDay"
                            injectedStrings={[contributionDay]}
                        />
                    </div>
                </div>
            );
        }

        const objectiveDetails = (
            <div className="ra-custom-plan-by-objective-view__objective-box-wrapper">
                <div className="ra-custom-plan-by-objective-view__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-type"
                        injectedStrings={[goalType]}
                    />
                </div>
                <div className="ra-custom-plan-by-objective-view__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-name"
                        injectedStrings={[goalName]}
                    />
                </div>
                <div className="ra-custom-plan-by-objective-view__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-amount"
                        injectedStrings={[objectiveAmount]}
                    />
                </div>
                <div className="ra-custom-plan-by-objective-view__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-initialContribution"
                        injectedStrings={[initialContributionAmount]}
                    />
                </div>
                <div className="ra-custom-plan-by-objective-view__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-objectiveEndDate"
                        injectedStrings={[endDate]}
                    />
                </div>
            </div>
        );

        return (
            <div className="row ra-custom-plan-by-objective-view__purchase-summary-section">
                <div className="col-md-12">
                    <p>
                        <FormattedText
                            className="ra-custom-plan-by-objective-view__purchase-summary-title"
                            value="cc_raCustomPlanByObjective-purchaseConfirmationTitle"
                        />
                    </p>
                    <BlockInfo extraClass="ra-custom-plan-by-objective-view__purchase-summary-info">
                        <FormattedText
                            className="ra-custom-plan-by-objective-view__mandatory-text-heading"
                            value="cc_raCustomPlanByObjective-mandatoryText"
                        />
                        <FormattedText
                            className="ra-custom-plan-by-objective-view__purchase-summary-detail"
                            value="cc_raCustomPlanByObjective-purchaseSummaryDetail"
                            injectedStrings={[clientName, strategy]}
                        />
                        {objectiveDetails}
                        {monthlyContributionDetails}
                        <FormattedText
                            className="ra-custom-plan-by-objective-view__client-confirmation-text"
                            value="cc_raCustomPlanByObjective-clientConfirmationText"
                            injectedStrings={[clientName]}
                        />
                    </BlockInfo>
                </div>
            </div>
        );
    }

    render() {
        const {
            immCustomPlanByObjective,
            immExpectedProfitability,
            immTimeHorizonCheck,
            setSelectedStrategy,
            immSuitabilityTest,
            immPortfoliosNameHistory,
            immProfile,
        } = this.props;
        const objectiveEndDate = immCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const clientRiskProfile = immSuitabilityTest.getIn(
            ['results', 0, 'clientRiskProfileTitle'],
            '',
        );
        const maxAvailableInvestmentProfile = immTimeHorizonCheck.get(
            'maxTypeOfProduct',
        );
        const maxInvestmentProfile = immSuitabilityTest.getIn(
            ['results', 0, 'maxTypeOfProduct'],
            0,
        );
        const candidateStrategy = immCustomPlanByObjective.get(
            'selectedStrategy',
        );
        const selectedStrategy =
            maxInvestmentProfile >= candidateStrategy
                ? candidateStrategy
                : null;
        const initialContributionAmount = immCustomPlanByObjective.get(
            'initialContributionAmount',
        );
        const hireButtonDisabled = this.shouldDisableHireButton();
        const title = immCustomPlanByObjective.get('objective');
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const header = this.buildHeader(
            title,
            clientRiskProfile,
            hireButtonDisabled,
            namesHistory,
        );
        const infoSection = this.buildInfoSection();
        const footer = this.buildFooter(hireButtonDisabled);
        const objectiveAmount = immCustomPlanByObjective.get('objectiveAmount');
        const goal = immCustomPlanByObjective.get('objectiveAmount');
        const goalType =
            immCustomPlanByObjective.get('objectiveType') || 'others';
        const modal = this.state.isModalOpen ? this.buildModal() : null;
        const immProductsChartData = immExpectedProfitability.get(
            'barChartData',
        );
        const suitabilityTestEndDate = formatDate(
            immSuitabilityTest.getIn(['results', 0, 'timestamp']),
        );
        const endDate = formatDate(objectiveEndDate);
        const clientName = PersonalDataHelper.getFullName(immProfile, false);
        const isLessThanMinimumInvestment =
            initialContributionAmount < MINIMUM_OBJECTIVE_AMOUNT;
        const currentStrategy = !!selectedStrategy
            ? selectedStrategy
            : maxAvailableInvestmentProfile;
        const strategyName =
            Portfolios[currentStrategy] &&
            Portfolios[currentStrategy].portfolioName;
        const contributionDay = immCustomPlanByObjective.get('contributionDay');
        const monthlyContributionAmount = immCustomPlanByObjective.get(
            'recurringContributionAmount',
        );

        let suitabilityWarningMessage,
            minimumInvestmentWarningMessage,
            investmentProfileDetailText,
            prePurchaseConfirmationMessage,
            purchaseSummaryMessage;

        const status = immTimeHorizonCheck.get('status');

        let contribution, strategiesContent;

        if (immProductsChartData) {
            contribution = immProductsChartData.getIn([
                0,
                1,
                'contributionNet',
            ]);
        }

        const displayStrategyMessage =
            (contribution > objectiveAmount ||
                initialContributionAmount > objectiveAmount) &&
            ![
                TIME_HORIZON_CHECK_NOT_PERFORMED,
                TIME_HORIZON_CHECK_ERROR,
                TIME_HORIZON_CHECK_WARNING,
            ].includes(status);
        const strategyMessageContent = displayStrategyMessage
            ? this.buildStrategyGraphMessage()
            : null;

        if (this.shouldRenderLoading()) {
            return (
                <div className="ra-custom-plan-by-objective-view__loading-wrapper">
                    <LoadingSection />
                </div>
            );
        }

        if (__CONTACT_CENTER__) {
            const recurringContributionAmount =
                contribution - initialContributionAmount;
            const minExpectedAmount = immProductsChartData.getIn([
                selectedStrategy - 1,
                1,
                'low',
            ]);
            const maxExpectedAmount = immProductsChartData.getIn([
                selectedStrategy - 1,
                1,
                'up',
            ]);
            const minProfitability = Math.abs(contribution - minExpectedAmount);
            const maxProfitability = Math.abs(contribution - maxExpectedAmount);
            const hasPeriodicContribution =
                immCustomPlanByObjective.get('recurringContributionAmount') > 0;
            const periodicContributionText = hasPeriodicContribution
                ? `${formatText(
                      'raCustomPlanByObjective-raCustomPlanByObjective_periodicContributionText',
                  )} ${formatDate(objectiveEndDate)}`
                : null;

            if (endDate < suitabilityTestEndDate) {
                suitabilityWarningMessage = this.buildSuitabilityWarningMessage(
                    clientName,
                    suitabilityTestEndDate,
                );
            }

            isLessThanMinimumInvestment
                ? (minimumInvestmentWarningMessage = this.buildMinimumAmountInvestmentMessage(
                      clientName,
                  ))
                : null;

            investmentProfileDetailText = this.buildInvestmentProfileMessage(
                selectedStrategy,
                clientName,
                maxAvailableInvestmentProfile,
            );
            prePurchaseConfirmationMessage = this.buildPrePurchaseConfirmationMessage(
                clientName,
                strategyName,
                initialContributionAmount,
                recurringContributionAmount,
                minProfitability,
                maxProfitability,
                minExpectedAmount,
                maxExpectedAmount,
                periodicContributionText,
                endDate,
            );
            purchaseSummaryMessage = this.buildPurchaseSummaryMessage(
                clientName,
                strategyName,
                goalType,
                title,
                initialContributionAmount,
                objectiveAmount,
                formatDate(objectiveEndDate),
                monthlyContributionAmount,
                recurringContributionAmount,
                contributionDay,
                clientName,
            );
        }

        const hasStrategyGraphData =
            !!initialContributionAmount &&
            !!objectiveAmount &&
            !!objectiveEndDate &&
            !immTimeHorizonCheck.get('isFetching');
        const goalAmountError = immCustomPlanByObjective.get('errorAmountMin');
        const initialAmountError = immCustomPlanByObjective.get(
            'errorInitialMin',
        );
        const recurringAmountError = immCustomPlanByObjective.get(
            'errorPeriodicityMin',
        );
        const amountValid =
            !goalAmountError && !initialAmountError && !recurringAmountError;

        if (hasStrategyGraphData && amountValid) {
            strategiesContent = (
                <RAStrategiesGraph
                    goal={goal}
                    immExpectedProfitability={immExpectedProfitability}
                    initialContributionAmount={initialContributionAmount}
                    objectiveEndDate={objectiveEndDate}
                    onStrategyClick={setSelectedStrategy}
                    maxAvailableInvestmentProfile={
                        maxAvailableInvestmentProfile
                    }
                    maxInvestmentProfile={maxInvestmentProfile}
                    selectedStrategy={selectedStrategy}
                    showDescription={true}
                    sourceUrl="goal"
                    prePurchaseConfirmationMessage={
                        prePurchaseConfirmationMessage
                    }
                />
            );
        }

        if (immExpectedProfitability.get('isFetching')) {
            strategiesContent = <LoadingSection />;
        }

        let middleSectionInfo;
        if (objectiveEndDate) {
            middleSectionInfo = (
                <div className="ra-custom-plan-by-objective-view__section-sub-info">
                    <FormattedText
                        value="raCustomPlanByObjective-middleSectionInfo"
                        injectedStrings={[
                            formatDate(objectiveEndDate, DATE_FORMAT_ES),
                        ]}
                    />
                </div>
            );
        }

        return (
            <div className="ra-custom-plan-by-objective-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RAOKCover
                            size="medium"
                            section={goalType}
                            customClass="col-xs-12"
                        >
                            {header}
                        </RAOKCover>
                    </div>
                </div>
                <div className="row ra-custom-plan-by-objective-view__container--salmon">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ra-custom-plan-by-objective-view__section-scheme-contribution">
                                        {modal}
                                        <RASchemeSettingContribution
                                            immCustomPlanByObjective={
                                                immCustomPlanByObjective
                                            }
                                            onObjectiveAmountChange={ // eslint-disable-line
                                                this.props.setObjectiveAmount
                                            }
                                            onObjectiveEndDateChange={ // eslint-disable-line
                                                this
                                                    .handleObjectiveEndDateChange
                                            }
                                            onObjectiveEndDateError={
                                                this.handleObjectiveEndDateError
                                            }
                                            onInitialContributionChange={ // eslint-disable-line
                                                this.props
                                                    .setInitialContributionAmount
                                            }
                                            onRecurringContributionChange={ // eslint-disable-line
                                                this.props
                                                    .setRecurringContributionAmount
                                            }
                                            onPeriodicityChange={
                                                this.handlePeriodicityChange
                                            }
                                            onContributionDayChange={
                                                this.handleContributionDayChange
                                            }
                                            onResetClick={this.handleResetClick}
                                            updateObjective={
                                                this.props.updateObjective
                                            }
                                            disableSaveSimulationButtonAction={
                                                this.props
                                                    .disableSaveSimulationButton
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            {strategyMessageContent}
                            <RATimeHorizonCheck />
                            {suitabilityWarningMessage}
                            {minimumInvestmentWarningMessage}
                            {investmentProfileDetailText}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ra-custom-plan-by-objective-view__section-middle">
                                        <h3 className="ra-custom-plan-by-objective-view__section-title">
                                            <FormattedText value="raCustomPlanByObjective-middleSectionTitle" />
                                        </h3>
                                        <div className="ra-custom-plan-by-objective-view__section-button">
                                            <RARiskButton
                                                onClick={this.handleOnLinkClick}
                                            />
                                        </div>
                                        {middleSectionInfo}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ra-custom-plan-by-objective-view__section-middle">
                                        {strategiesContent}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">{infoSection}</div>
                            </div>
                            {purchaseSummaryMessage}
                        </div>
                    </div>
                </div>
                <div
                    className="row ra-custom-plan-by-objective-view__container--blue"
                    ref={componentInstance => {
                        this.raCtaFooter = componentInstance;
                    }}
                >
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">{footer}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RACustomPlanByObjectiveView.propTypes = {
    disableSaveSimulationButton: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    getSimulation: PropTypes.func.isRequired,
    getPDFContract: PropTypes.func.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    immHireManagementPlan: PropTypes.object.isRequired,
    immExpectedProfitability: PropTypes.object.isRequired,
    immPortfoliosNameHistory: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    immSimulation: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immTimeHorizonCheck: PropTypes.object.isRequired,
    notificationSuccess: PropTypes.func.isRequired,
    requestProjectionChart: PropTypes.func.isRequired,
    requestSimulation: PropTypes.func.isRequired,
    resetMaxTypeOfProduct: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetSchemeContribution: PropTypes.func.isRequired,
    saveSimulation: PropTypes.func.isRequired,
    saveGoal: PropTypes.func.isRequired,
    saveSimulationRequest: PropTypes.func.isRequired,
    setContributionDay: PropTypes.func.isRequired,
    setInitialContributionAmount: PropTypes.func.isRequired,
    setObjectiveAmount: PropTypes.func.isRequired,
    setObjectiveEndDate: PropTypes.func.isRequired,
    setObjectiveEndDateError: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
    setRecurringContributionAmount: PropTypes.func.isRequired,
    setSelectedStrategy: PropTypes.func.isRequired,
    setScrollHeight: PropTypes.func.isRequired,
    setTimeHorizonCheck: PropTypes.func.isRequired,
    timeHorizonCheck: PropTypes.func.isRequired,
    updateObjective: PropTypes.func.isRequired,
    requestPortfolioDistribution: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        immHireManagementPlan: state.raHireManagementPlan,
        immExpectedProfitability: state.raExpectedProfitability,
        immPortfoliosNameHistory: state.raPortfoliosNameHistory,
        immProfile: state.profile,
        immRAFeatureFlag: state.raFeatureFlag,
        immSuitabilityTest: state.raSuitabilityTest,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        immSimulation: state.raSimulation,
        flagBasedFeatures: state.flagBasedFeatures,
        immCheckStatus: state.raCheckStatus,
    }),
    {
        disableSaveSimulationButton:
            raCustomPlanByObjectiveActions.disableSaveSimulationButton,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        getSimulation: raCustomPlanByObjectiveActions.getSimulation,
        getPDFContract: raHireManagementPlanActions.getPDFContract,
        notificationSuccess: notification.success,
        requestProjectionChart:
            expectedProfitabilityActions.requestProjectionChart,
        saveGoal: RASetGoalActions.saveGoal,
        saveSimulationRequest: raSaveSimulationActions.saveSimulationRequest,
        reset: raManagementPlanActions.reset,
        resetSchemeContribution:
            raCustomPlanByObjectiveActions.resetSchemeContribution,
        resetMaxTypeOfProduct: raTimeHorizonCheckActions.resetMaxTypeOfProduct,
        saveSimulation: raManagementPlanActions.saveSimulation,
        requestSimulation: raManagementPlanActions.requestSimulation,
        setContributionDay: raCustomPlanByObjectiveActions.setContributionDay,
        setInitialContributionAmount:
            raCustomPlanByObjectiveActions.setInitialContributionAmount,
        setObjectiveAmount: raCustomPlanByObjectiveActions.setObjectiveAmount,
        setObjectiveEndDate: raCustomPlanByObjectiveActions.setObjectiveEndDate,
        setObjectiveEndDateError:
            raCustomPlanByObjectiveActions.setObjectiveEndDateError,
        setPeriodicity: raCustomPlanByObjectiveActions.setPeriodicity,
        setRecurringContributionAmount:
            raCustomPlanByObjectiveActions.setRecurringContributionAmount,
        setSelectedStrategy: raCustomPlanByObjectiveActions.setSelectedStrategy,
        setScrollHeight: raCustomPlanByObjectiveActions.setScrollHeight,
        setTimeHorizonCheck: raTimeHorizonCheckActions.setTimeHorizonCheck,
        timeHorizonCheck: raTimeHorizonCheckActions.timeHorizonCheck,
        updateObjective: raCustomPlanByObjectiveActions.updateObjective,
        requestPortfolioDistribution:
            portfolioDistributionActions.requestPortfolioDistribution,
    },
)(withRouter(RACustomPlanByObjectiveView));
